// item 473 — the "Payroll +" extra-pay documents (COMM-/TIME-/IC-). Mirrors the backend
// BizExtraPayDocDto + the ExtraPayDoc enums. Minted at approval → entered (QB owns payment).

export enum ExtraPayDocType {
  Commission = 0,
  Timesheet = 1,
  IndependentContractor = 2,
}

export enum ExtraPayDocStatus {
  Approved = 0,
  Entered = 1,
}

export const EXTRA_PAY_TYPE_LABEL: Record<ExtraPayDocType, string> = {
  [ExtraPayDocType.Commission]: 'Commission',
  [ExtraPayDocType.Timesheet]: 'Timesheet',
  [ExtraPayDocType.IndependentContractor]: 'Independent Contractor',
};

export const EXTRA_PAY_STATUS_LABEL: Record<ExtraPayDocStatus, string> = {
  [ExtraPayDocStatus.Approved]: 'Approved',
  [ExtraPayDocStatus.Entered]: 'Entered',
};

export interface ExtraPayDoc {
  id: string;
  number: string;
  docType: ExtraPayDocType;
  earnerUserId: string;
  earnerName?: string;
  periodStart: string;
  periodEnd: string;
  totalAmount: number;
  notes?: string;
  icInvoiceNumber?: string;
  status: ExtraPayDocStatus;
  approvedDate: string;
  approvedByName?: string;
  enteredDate?: string;
  enteredByName?: string;
  payFromDraw?: boolean; // item 1489 — earner on a draw: pay off the draw report, not this doc
}

// the payload to approve an earner's hand-picked submitted entries → mint a numbered doc
export interface ExtraPayApprovePayload {
  earnerUserId: string;
  docType: ExtraPayDocType;
  entryIds: string[];
  periodStart: string;
  periodEnd: string;
  notes?: string;
}
